import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { CheckCircle, Truck, LayoutDashboard } from "lucide-react";

const STORAGE_KEY = "transportmate_subscription_confirmed";

export const SubscriptionConfirmationDialog = () => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const flag = localStorage.getItem(STORAGE_KEY);
    if (flag === "pending") {
      setOpen(true);
    }
  }, []);

  const handleDismiss = () => {
    localStorage.setItem(STORAGE_KEY, "shown");
    setOpen(false);
  };

  const handleCreateJob = () => {
    localStorage.setItem(STORAGE_KEY, "shown");
    setOpen(false);
    navigate("/create-job");
  };

  return (
    <Dialog open={open} onOpenChange={(v) => { if (!v) handleDismiss(); }}>
      <DialogContent className="sm:max-w-lg">
        <DialogHeader className="text-center space-y-4">
          <div className="flex justify-center">
            <div className="w-16 h-16 rounded-full bg-primary/10 flex items-center justify-center">
              <CheckCircle className="w-10 h-10 text-primary" />
            </div>
          </div>
          <DialogTitle className="text-2xl font-bold text-center">
            Thank you for subscribing to TransportMate
          </DialogTitle>
          <DialogDescription className="text-left space-y-4 text-sm leading-relaxed">
            <p>
              Your subscription is now active and you're ready to run transport jobs with automated proof, tracking, and invoicing.
            </p>
            <p>
              TransportMate is continuously improving based on real operator feedback. If anything doesn't look right or you experience an issue, please report it using the <strong>Help</strong> or <strong>Report Fault</strong> section — fixes are prioritised quickly.
            </p>
            <p className="text-muted-foreground italic">
              You're now part of our growing network of vehicle transport professionals using TransportMate every day.
            </p>
          </DialogDescription>
        </DialogHeader>

        <div className="flex flex-col sm:flex-row gap-3 mt-4">
          <Button onClick={handleCreateJob} className="flex-1" size="lg">
            <Truck className="w-4 h-4 mr-2" />
            Create Your First Job
          </Button>
          <Button onClick={handleDismiss} variant="outline" className="flex-1" size="lg">
            <LayoutDashboard className="w-4 h-4 mr-2" />
            Go to Dashboard
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
